import { PackedOnEnum } from 'api';

import { formatPackedOn } from '../../utils/formatPackedOn/formatPackedOn';
import { SelectField, type SelectFieldProps } from '../SelectField/SelectField';

const PACKED_ON_OPTIONS =
  PackedOnEnum &&
  Object.values(PackedOnEnum).map((packedOn: PackedOnEnum) => ({
    label: formatPackedOn(packedOn),
    value: packedOn,
  }));

type Props = Omit<SelectFieldProps, 'options'>;

export const PackedOnSelectField = (props: Props) => {
  return <SelectField options={PACKED_ON_OPTIONS} {...props} />;
};
